import React from "react";
import "./landing.css";

export default function Landing() {
  return (
    <div className="landing container">

      {/* NAVBAR */}
      <header className="navbar">
        <img
          src="/assets/branding/bingeshark-logo.png"
          alt="BingeShark"
          style={{
            width: "220px",
            marginBottom: "2rem"
          }}
        />

        <div className="nav-actions">
          <button onClick={() => {
            const el = document.getElementById("features");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}>
            Features
          </button>

          <button onClick={() => window.location.href = "/login.html"}>
            Sign Up
          </button>
        </div>
      </header>

      {/* HERO */}
      <section className="hero">
        <div className="hero-left">
          <h1>Stream the Culture. Live the Vibe.</h1>

          <p>
            Live TV, On-Demand, and premium content — all in one platform.
          </p>

          <button className="cta" onClick={() => window.location.href = "/login.html"}>
            Get Started — Live TV & Movies for $17.99
          </button>

          <span className="sub-note">
            No contracts. Cancel anytime.
          </span>
        </div>

        <div className="hero-right">
          <img 
          className="hero-image"
          src="/assets/screenshots/dashboard-preview.png" 
          alt="BingeShark streaming platform dashboard preview" 
        />
        </div>
      </section>

     <div className="ondemand-section">
  <h2>Shark OnDemand</h2>

  <p>
    Stream what you want, when you want. BingeShark OnDemand brings together
    trending shows, live event replays, and curated content — all organized
    for instant access and seamless viewing.
  </p>

  {/* Featured Trailer */}
  <div className="ondemand-preview">
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source
            src="/assets/videos/library-preview.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      {/* Categories */}
      <div className="ondemand-grid">
        <div>🔥 Trending Now</div>
        <div>🎬 Action & Drama</div>
        <div>⚽ Sports & Live Events</div>
        <div>🎭 Reality & Lifestyle</div>
        <div>📺 Documentaries</div>
        <div>🧠 Cultural & Commentary</div>
      </div>
    </div>

      {/* FEATURES */}
      <section id="features" className="features">

        <div className="feature-block">
          <div className="feature-text">
            <span className="tag">LIVE TV EXPERIENCE</span>

            <h2>
              Old school TV guide feel.<br />
              New school streaming power.
            </h2>

            <p>
              Browse live channels with a structured guide built for real-time viewing.
            </p>
          </div>

          <img
            src="/assets/screenshots/epg-preview.png"
            alt="BingeShark live TV guide interface"
          />
        </div>

      </section>

      {/* FINAL CTA */}
      <section className="final-cta">
        <h2>Ready to Stream the Culture?</h2>

        <button className="cta" onClick={() => window.location.href = "/login.html"}>
          Start Watching — Only $17.99
        </button>
      </section>
      <footer className="footer">
        <p>
          © 2026 BingeShark |
          <a href="/terms.html">Terms of Use</a> |
          <a href="/privacy.html">Privacy Policy</a>
        </p>
      </footer>

    </div>
  );
}